export default {
  TokenToUsd: ["0x6db3972c6a5535708e7A4F7Ad52F24d178D9A93e", "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c", "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56", "0x55d398326f99059fF775485246999027B3197955"],
  UsdToToken: ["0x55d398326f99059fF775485246999027B3197955", "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56", "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c", "0x6db3972c6a5535708e7A4F7Ad52F24d178D9A93e"],
  LockUp: {
    56: "0x53509561113e1DD131a6b0ff66283Ce5B15Ed2b2", // new claimreward changed
    97: "0x0fd0B642163Ec62b4d4b06D3999cF70184F63d3D", // new
  },
  DrivenFarm: {
    56: "0x1f61ACdeE563af6064570347870c6009c016081A", // Mainnet
    97: "0x2dcb513bb226e1ae4093f60b35eb003e89615fc9",//new testnet
  },
  DividendToken: {
    // 56: "0x6db3972c6a5535708e7A4F7Ad52F24d178D9A93e", // new mainnet
    56: "0x6db3972c6a5535708e7A4F7Ad52F24d178D9A93e", // new mainnet
    97: "0xE6832f3Fa3A40a58A6e3d3985E1c746fc1999Ee3", // new testnet
  },
  LpToken: {
    56: "0xA8e72b739841A18751B9b83d0EBCCFbC1b489590",
    97: "0xC46cBCa50101c8E8A7C12f314e25F188B00bCb98",
    // 97: "0x0bc6b2a476dac6d4fecaedb927df465ad9979ccf", // uniswapV2pair
  },
  LpTokenRouter: {
    56: "0x10ed43c718714eb63d5aa57b78b54704e256024e", // mainnet
    97: "0x9Ac64Cc6e4415144C455BD8E4837Fea55603e5c3", //testnet
  },
  multiCall: {
    56: "0xfF6FD90A470Aaa0c1B8A54681746b07AcdFedc9B",
    97: "0x8F3273Fb89B075b1645095ABaC6ed17B2d4Bc576",
  },
  WBNB: {
    56: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    97: "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd"
  },
  USDT: {
    56: "0x55d398326f99059fF775485246999027B3197955",
    97: "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd"
  }
};












